import { loadable } from '@direct-frontend/modules-render';
import { DelayedSuspense } from '#shared/components/DelayedSuspense';
import { PageStub } from '#shared/components/PageStub';

const AbcAnalysisLazy = loadable(() => import(/* webpackChunkName: "AbcAnalysis" */ './AbcAnalysisSuspense'));

export const AbcAnalysisAsync = () => (
    <DelayedSuspense fallback={<PageStub />}>
        <AbcAnalysisLazy />
    </DelayedSuspense>
);
